/*
  Perguntas frequentes (Match Day).

  Regra medida na referencia em 2026-08-26: o acordeao e EXCLUSIVO - abrir uma pergunta
  fecha a que estava aberta, inclusive quando as duas ficam em colunas diferentes. O
  clique na pergunta ja aberta fecha ela.

  A animacao mora no CSS (grid-template-rows). Aqui so alternamos a classe e o estado
  de acessibilidade, e e por isso que o arquivo e curto de proposito.
*/
(function () {
  if (window.__mdFaqInit) return;
  window.__mdFaqInit = true;

  function fechar(item) {
    if (!item || !item.classList.contains('esta-aberto')) return;
    item.classList.remove('esta-aberto');
    var b = item.querySelector('.md-faq__pergunta');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function alternar(botao) {
    var item = botao.closest('.md-faq__item');
    var faixa = botao.closest('.md-faq');
    if (!item || !faixa) return;

    var jaAberto = item.classList.contains('esta-aberto');

    // exclusivo: a faixa inteira, e nao so a coluna - e assim que a referencia se comporta
    var abertos = faixa.querySelectorAll('.md-faq__item.esta-aberto');
    for (var i = 0; i < abertos.length; i++) fechar(abertos[i]);

    if (!jaAberto) {
      item.classList.add('esta-aberto');
      botao.setAttribute('aria-expanded', 'true');
    }
  }

  // delegacao no documento: cobre as secoes que o editor de tema injeta depois da carga
  document.addEventListener('click', function (evento) {
    var botao = evento.target.closest ? evento.target.closest('.md-faq__pergunta') : null;
    if (botao) alternar(botao);
  });

  /*
    No editor, selecionar um bloco no painel da esquerda deve abrir a pergunta
    correspondente - senao o Ivan clica na resposta pra editar e nao ve nada acontecer.
  */
  document.addEventListener('shopify:block:select', function (evento) {
    var item = evento.target.closest ? evento.target.closest('.md-faq__item') : null;
    if (!item) return;
    var botao = item.querySelector('.md-faq__pergunta');
    if (botao && !item.classList.contains('esta-aberto')) alternar(botao);
  });
})();
